import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
// sass
import '../../css/domain/Claim/CreateClaim.scss';
// selectors
import { claimsDataSelector } from '../../redux/Claims/selector';
import { authenticationDataSelector } from '../../redux/Authentication/selector';
import FormioComponents from '../../FormioComponents';
import { getClaims, getGWClaims } from '../../redux/Claims/actions';

function CreateClaim(props) {
  const { claims, authentication } = props;
  const [currentLanguage, setCurrentLanguage] = useState('');
  const claimsData = claims.data;
  const claimId = window.sessionStorage.getItem('claimId');
  const dispatch = useDispatch();
  const [claimData, setClaimData] = useState(claimsData.find((claim) => claim.claimId === claimId) || null);
  const { sonnetAddressBookUid } = authentication;

  useEffect(() => {
    if (sonnetAddressBookUid && !claimData) {
      dispatch(getClaims(sonnetAddressBookUid));
      dispatch(getGWClaims(sonnetAddressBookUid));
    }
  }, [dispatch, sonnetAddressBookUid]);

  useEffect(() => {
    setClaimData(claimsData.find((claim) => claim.claimId === claimId));
  }, [claims]);

  useEffect(() => {
    if (authentication?.preferredLang) {
      setCurrentLanguage(authentication.preferredLang === 'en_CA' ? 'en' : 'fr');
    } else {
      setCurrentLanguage('en');
    }
  }, [authentication]);

  useEffect(() => {
    // Scroll to the page top
    setTimeout(() => {
      document.getElementsByClassName('app')[0].scrollTop = 0;
    }, 100);
  }, []);

  return (
    claimData && claimId && (
      <FormioComponents
        claimId={claimId}
        key={claimId}
        claimData={claimData}
        language={currentLanguage}
      />
    )
  );
}

const mapStateToProps = (state) => ({
  claims: claimsDataSelector(state.claims),
  authentication: authenticationDataSelector(state.authentication),
});

export default injectIntl(connect(mapStateToProps)(CreateClaim));
